import {createContext, FC, ReactNode, useContext, useState} from 'react'
import {initialQueryState} from '../../../../../../_metronic/helpers'

interface QueryState {
  searchTerm?: string
  page?: number
  items_per_page?: number
  sort?: string
  order?: 'asc' | 'desc'
}

interface QueryRequestContextProps {
  state: QueryState
  updateState: (updates: Partial<QueryState>) => void
}

const QueryRequestContext = createContext<QueryRequestContextProps>({
  state: initialQueryState,
  updateState: () => {},
})

const QueryRequestProvider: FC<{children: ReactNode}> = ({children}) => {
  const [state, setState] = useState<QueryState>(initialQueryState)

  const updateState = (updates: Partial<QueryState>) => {
    const updatedState = {...state, ...updates} as QueryState
    setState(updatedState)
  }

  const value = {
    state,
    updateState,
  }

  return <QueryRequestContext.Provider value={value}>{children}</QueryRequestContext.Provider>
}

const useQueryRequest = () => useContext(QueryRequestContext)

export {QueryRequestProvider, useQueryRequest}
